import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { FormErrorComponent } from '@shared/components';
import { RequiredLabelDirective } from '@shared/directives';
import { FormGroupOf, ResetEmailRequest } from '@shared/models';
import { AuthHttpService, ToastsService } from '@shared/services';
import { FormGenerator, FormGroupExtension } from '@shared/utils';

import { AuthCardComponent } from '../auth-card/auth-card.component';

@Component({
  templateUrl: './reset-email.component.html',
  imports: [
    ...COMMON_STANDALONE_IMPORTS,
    TranslateModule,
    FormErrorComponent,
    PasswordModule,
    ButtonModule,
    RequiredLabelDirective,
    AuthCardComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetEmailComponent implements OnInit {
  resetEmailComponentLoader = 'resetEmailComponentLoader';

  editForm: FormGroup<FormGroupOf<ResetEmailRequest>> = FormGenerator.initResetEmailForm();

  constructor(
    private authService: AuthHttpService,
    public toastsService: ToastsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const email = this.activatedRoute.snapshot.queryParamMap.get('email');
    const oldEmail = this.activatedRoute.snapshot.queryParamMap.get('oldEmail');

    this.editForm = FormGenerator.initResetEmailForm(new ResetEmailRequest(email, oldEmail, null, token));
  }

  onSubmit(): void {
    if (FormGroupExtension.hasAnyValidationError(this.editForm)) {
      FormGroupExtension.markFormAsDirtyAndTouched(this.editForm);
      this.translate.instant('error.invalidForm');
      return;
    }
    this.authService.resetEmail(this.resetEmailComponentLoader, this.editForm.getRawValue()).subscribe({
      next: () => {
        this.toastsService.showSuccess(this.translate.instant('auth.resetEmail.newEmailSavedToast'));
        this.router.navigate(['auth', 'login']);
      },
      error: (error) => this.toastsService.showError(error),
    });
  }
}
